/* eslint camelcase: 0 */
import { toPriceProps } from './price'
import { toAgencyProps } from './agency'
import { toAreaProps } from './area'
import { Hospital } from '@/infrastructure/network/Monitaro/schema/models'
import { IHospitalProps, EmptyHospitalPropsFactory } from '@/entities/Hospital'

export const toHospitalProps = (props: Hospital | null | undefined): IHospitalProps => {
  if (!props) {
    return EmptyHospitalPropsFactory()
  }

  const {
    id,
    price,
    price_id,
    agencies,
    areas,
    name,
    kana,
    chargeable,
    approved,
    activation,
    rocotime,
    agency,
    properties,
    flags,
    doctors_count,
    users_count,
    term,
    started_at,
    created_at,
    updated_at
  } = props

  return EmptyHospitalPropsFactory({
    id,
    price: toPriceProps(price),
    priceId: price_id,
    agencies: agencies?.map(toAgencyProps),
    areas: areas?.map(toAreaProps),
    name,
    kana,
    chargeable,
    approved,
    activation,
    rocotime,
    agency,
    properties,
    flags,
    doctorsCount: doctors_count,
    usersCount: users_count,
    term,
    startedAt: started_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
